var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      ref: "vspopup-role",
      attrs: { title: _vm.$t("Roles"), active: _vm.visible, id: "popup-role" },
      on: {
        "update:active": function($event) {
          _vm.visible = $event
        },
        close: _vm.closePopup
      }
    },
    [
      _c("tag-suggestion", {
        ref: "select_sugestion",
        staticClass: "row-start-1",
        attrs: {
          max: 20,
          column: "name",
          orderBy: "name",
          model: "Role",
          label: _vm.$t("role.selected"),
          modelToTagMapping: _vm.mapModelToTag,
          placeholderText: _vm.$t("form_min_caracter_", [3])
        },
        model: {
          value: _vm.selectedItems,
          callback: function($$v) {
            _vm.selectedItems = $$v
          },
          expression: "selectedItems"
        }
      }),
      _c(
        "div",
        { staticClass: "flex flex-row justify-end gap-4 mt-2" },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "primary" },
              on: {
                click: function($event) {
                  return _vm.closePopup()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("action.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }